var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TaskCenter",attrs:{"id":"TaskCenter"},on:{"click":function($event){return _vm.toTaskCenter()}}},[_vm._v(" 任务中心 ")])}
var staticRenderFns = []

export { render, staticRenderFns }